// src/components/ui/toast/components/ToastItem.tsx
'use client';

import React from 'react';
import type { ToastInternal } from '../context/ToastContext';
import { useToastTimer } from '../hooks/useToastTimer';
import { Toast } from './Toast';

interface Props {
  toast: ToastInternal;
  onClose: () => void;
}

/** ToastItem — attaches timing behavior to the pure view. */
export const ToastItem: React.FC<Props> = ({ toast, onClose }) => {
  const { paused, remainingMs, eventHandlers } = useToastTimer(
    toast.duration,
    onClose
  );

  return (
    <div {...eventHandlers}>
      <Toast
        message={toast.message}
        type={toast.type}
        progressMs={remainingMs}
        paused={paused}
        onClose={onClose}
      />
    </div>
  );
};
